import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import MapIcon from '@material-ui/icons/Map'

const styles = theme => ({
  paper: {
    position: 'absolute',
    top: 10,
    right: 10,
    bottom: 10,
    left: 10,
    textAlign: 'center',
    padding: theme.spacing.unit
  },
  header: {
    fontSize: 48,
    margin: theme.spacing.unit*2
  },
  container: {
    width: 900,
    margin: 'auto'
  },
  card: {
    cursor: 'pointer',
    width: 250,
    height: 250,
    margin: 'auto'
  },
  icon: {
    margin: theme.spacing.unit,
    marginBottom: 0,
    fontSize: 128
  }
})

class App extends React.Component {

  state = { selected: null }

  onMouseOver = e => this.setState({ selected: e.target.id })

  onMouseOut = () => this.setState({ selected: null })

  render() {
    const { classes } = this.props
    return (
      <Paper className={classes.paper} elevation={1}>
        <Typography gutterBottom variant='headline' color='primary' className={classes.header}>
          Welcome to AddressCloud!
        </Typography>
        <Grid container justify='center' spacing={16} className={classes.container}>
          <Grid item xs={12}>
            <Typography gutterBottom component='p'>
              Please select the application you wish to access:
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Card
              id='admin'
              className={classes.card}
              onClick={() => window.location.href = 'https://admin.addresscloud.com'}
              onMouseOver={this.onMouseOver}
              onMouseOut={this.onMouseOut}
              elevation={this.state.selected === 'admin' ? 4 : 1}
            >
              <AccountCircleIcon color='secondary' className={classes.icon} />
              <CardContent>
                <Typography gutterBottom color='primary' variant='headline' component='h3'>
                  Admin
                </Typography>
                <Typography component='p'>
                  Manage your account and perform adhoc searches
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card
              id='maps'
              className={classes.card}
              onClick={() => window.location.href = 'https://maps.addresscloud.com'}
              onMouseOver={this.onMouseOver}
              onMouseOut={this.onMouseOut}
              elevation={this.state.selected === 'maps' ? 4 : 1}
            >
              <MapIcon color='secondary' className={classes.icon} />
              <CardContent>
                <Typography gutterBottom color='primary' variant='headline' component='h3'>
                  Maps
                </Typography>
                <Typography component='p'>
                  View addresses on a map and perform risk assessments
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card
              id='batch'
              className={classes.card}
              onClick={() => window.location.href = 'https://batch.addresscloud.com'}
              onMouseOver={this.onMouseOver}
              onMouseOut={this.onMouseOut}
              elevation={this.state.selected === 'batch' ? 4 : 1}
            >
              <CloudUploadIcon color='secondary' className={classes.icon} />
              <CardContent>
                <Typography gutterBottom color='primary' variant='headline' component='h3'>
                  Batch
                </Typography>
                <Typography component='p'>
                  Match, geocode and risk assess files of addresses
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    )
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(App)



// WEBPACK FOOTER //
// ./src/App.js